import React from "react";
import {NavLink} from "react-router-dom";
import useTranslation from "../../../i18n/useTranslation";
import {GlobalStyles} from "../../../constants/styles";

const ReadyToElevate = ({imgPath}) => {
    const {t} = useTranslation();

    return (
        <div className="jumbotron text-center mt-5 p-5 rounded"
             style={{backgroundColor: "#1f1f2e", color: "#ffffff"}}>
            <h2>{t('defaultHome.elevate.title')}</h2>
            <p>{t('defaultHome.elevate.subtitle')}</p>
            <NavLink to={'/register'}
                     className="btn btn-lg mr-3"
                     style={{backgroundColor: GlobalStyles.colors.canary, color: GlobalStyles.colors.woodsmoke}}
                     end>{t('common.getStarted')}</NavLink>
        </div>
    );
};

export default ReadyToElevate;
